<nz-form-control *ngIf="recordProperty !== undefined" class="check-box">
    <label nz-checkbox
    [class]="parentClass"
    [ngModel]="recordProperty.ValueAsObject === this.field.AdditionalInformationParsed.ValueYes"
    (ngModelChange)="checkBoxValueChanged()" [nzDisabled]="recordProperty.ReadOnly"></label>
</nz-form-control>
